import React from 'react';

export const BadRequest = () => {
  return <div>404 Bad Request</div>;
};
